import React, { useMemo } from 'react';
import * as S from './BookmarkFilters.styled';
import { useBreakpoint } from '@/hooks/useBreakpoint';

export const CategoriesLoader = () => {
  const { isDesktop } = useBreakpoint();

  const randomWidths = useMemo(() => {
    const loaderItems = isDesktop ? 6 : 3;

    return Array.from({ length: loaderItems }).map(() => {
      return Math.floor(Math.random() * (210 - 110 + 1)) + 110;
    });
  }, []);

  return randomWidths.map((randomWidth, idx) => {
    const isFirst = idx === 0;
    const firstWidth = isDesktop ? 165 : 80;
    const width = isFirst ? firstWidth : randomWidth;

    return <S.ItemLoader key={idx} $width={width} />;
  });
};
